// Rutas que ya viven en el portal nuevo. Una pantalla entra aquí en el mismo commit en que queda igual a la de Blazor
// (criterio de terminado); las demás se abren en el portal actual por su dirección, con su propio login.
export const migratedRoutes: RegExp[] = [
  // Inicio provisional (solo el título, pedido del dueño 2026-10-27): no depende de que el portal actual esté levantado.
  /^\/portal(\/index)?$/,
  /^\/portal\/chat\/configuracion\/etiquetas$/,
  // T19–T25: Chat unificado y chats internos (/portal/chats sin más queda en el portal actual por la política de grupos).
  /^\/portal\/chat(\/index)?$/,
  /^\/portal\/chats\/(nuevo-grupo|\d+|\d+\/participantes)$/,
  // T29–T31 · Configuración del Chat, Roles (redirige a Equipo), Bandejas y Canales, con sus direcciones históricas.
  /^\/portal\/(chat\/configuracion|configuracion\/chat)$/,
  /^\/portal\/chat\/configuracion\/roles(\/\d+)?$/,
  /^\/portal\/chat\/configuracion\/bandejas\/\d+\/reparto$/,
  /^\/portal\/bandejas(\/index|\/nueva|\/detalle|\/\d+)?$/,
  /^\/portal\/canales(\/index|\/whatsapp|\/reglas|\/\d+\/reglas)?$/,
  // T32 · Estadísticas.
  /^\/portal\/chat\/estadisticas$/,
  // T26–T28: Contactos (lista y ficha) y Respuestas.
  /^\/portal\/chat\/contactos(\/\d+)?$/,
  /^\/portal\/chat\/respuestas$/,
  // T17 y T18 · cuenta: recuperar, alta, cambio obligatorio, invitación, selector de empresa y soporte delegado.
  /^\/recuperar$/,
  /^\/register$/,
  /^\/cambiarpassword$/,
  /^\/invitacion\/aceptar$/,
  /^\/portal\/organizaciones$/,
  /^\/soporte\/(denegado|fin)$/,
  // Chat › Equipo (T33–T34): Miembros, Configurar agente, acceso efectivo y Grupos.
  /^\/portal\/chat\/equipo(\/miembros(\/\d+(\/acceso)?)?|\/grupos(\/\d+)?)?$/,
  // Horarios y disponibilidad de Chat › Configuración y las direcciones viejas que llevan allí (EquipoAnterior.razor).
  /^\/portal\/chat\/configuracion\/(horarios(\/\d+)?|cierres)$/,
  // Simulador: la ventana vive en el shell; /portal/simulacion la abre con el objetivo de la dirección.
  /^\/portal\/simulacion$/,
  /^\/portal\/chat\/equipo\/(horarios(\/\d+)?|cierres)$/,
  /^\/portal\/configuracion\/horarios$/,
  // Configuración de la empresa y Usuarios (decisión del dueño 2026-10-28: rediseño, no copia de Equipo y acceso; la
  // ficha de cada persona y Módulos siguen en el portal actual).
  /^\/portal\/configuracion(\/index)?$/,
  /^\/portal\/configuracion\/usuarios(\/nuevo)?$/,
  // Menú de la cuenta (2026-10-29, rediseño con el kit, no copia): Ajustes de la empresa, Mi perfil, Seguridad y Preferencias.
  /^\/portal\/configuracion\/empresa$/,
  /^\/portal\/(perfil|seguridad|preferencias)$/,
];

let legacyBase = "";

/** Dirección del portal actual para los módulos no migrados (la entrega el servidor en /api/portal/shell). */
export function setLegacyBase(url: string): void {
  legacyBase = url.replace(/\/+$/, "");
}

export function isMigrated(path: string): boolean {
  const clean = path.split(/[?#]/)[0]!.replace(/\/+$/, "").toLowerCase();
  return migratedRoutes.some((route) => route.test(clean));
}

/** El mismo destino en el portal actual, aunque su ruta ya esté migrada (una parte de la pantalla que aún no lo está). */
export function legacyHref(path: string): string {
  return legacyBase ? legacyBase + path : path;
}

/** Enlace a un destino: interno si está migrado; si no, el mismo destino en el portal actual. */
export function portalHref(path: string): string {
  if (/^[a-z]+:\/\//i.test(path) || path.startsWith("#")) return path;
  return isMigrated(path) || !legacyBase ? path : legacyBase + path;
}
